import {
  ORDER_METHODS,
  ORDER_REJECTED_REASON,
  PaymentMethod,
  RoomServiceLocationType
} from "../../../../services/exports/Constants";

export default {
  header: {
    order_canceled: "Bestellung storniert",
    track_order: "Deine Bestellung",
    order_info:
      "Bestellinformationen & Updates werden an deine E-Mail gesendet {{email}}",
  },
  order_status: {
    order_canceled: 'Bestellung storniert',
    confirmed_time: {
      text: 'Bestätigte {{type}}:',
      type_labels: {
        [ORDER_METHODS.ROOM_SERVICE]: 'zeit',
        [ORDER_METHODS.PICKUP]: 'Abholzeit',
        [ORDER_METHODS.DELIVERY]: 'Lieferzeit',
      },
    },
    estimated_time: {
      text: 'Geschätzte {{type}}:',
      type_labels: {
        [ORDER_METHODS.ROOM_SERVICE]: 'zeit',
        [ORDER_METHODS.PICKUP]: 'Abholzeit',
        [ORDER_METHODS.DELIVERY]: 'Lieferzeit',
      },
    },
  },
  order_type: {
    pickup: "Abholzeit",
    delivery: "Lieferzeit",
  },
  labels: {
    today: 'Heute',
  },
  order_status_toast: {
    order_reviewed: "#{{number}} Deine Bestellung wurde gesehen",
    order_confirmed: "#{{number}} Bestellung bestätigt {{time}}",
    order_preparation_up_time_changed:
      "#{{number}} {{type}} geändert auf {{time}}",
    order_preparing: "Deine Bestellung #{{number}} wird zubereitet",
    order_rejected: "#{{number}} Bestellung storniert",
  },
  warning_label: {
    order_rejected_reason: {
      [ORDER_REJECTED_REASON.AUTOMATIC]:
        "Leider können wir im Moment keine neuen Bestellungen annehmen, weil wir überlastet sind. Wir haben das Geld bereits an dich zurücküberwiesen und du solltest es spätestens innerhalb von 4 Werktagen erhalten. Solltest du das Geld nicht innerhalb von 4 Tagen erhalten, schreibe bitte an unseren digitalen Partner {{provider}} unter {{supportEmail}}. Wir entschuldigen uns dafür und würden uns freuen, wenn du in 1 Stunde noch einmal versuchst zu bestellen, falls du warten kannst.",
      [ORDER_REJECTED_REASON.CLOSING_SOON]:
        "Leider haben wir keine Zeit, um die Bestellung zu erledigen bevor wir schließen. Wir haben das Geld bereits an dich zurücküberwiesen und du solltest es spätestens innerhalb von 4 Werktagen erhalten. Solltest du das Geld nicht innerhalb von 4 Tagen erhalten, schreibe bitte an unseren digitalen Partner {{provider}} unter {{supportEmail}}. Bei Fragen möchten wir Dich bitten, das Restaurant anzurufen.",
      [ORDER_REJECTED_REASON.ITEM_UNAVAILABLE]:
        "Leider können wir den/die bestellten Artikel derzeit nicht anbieten. Wir haben das Geld bereits an dich zurücküberwiesen und du solltest es spätestens innerhalb von 4 Werktagen erhalten. Solltest du das Geld nicht innerhalb von 4 Tagen erhalten, schreibe bitte an unseren digitalen Partner {{provider}} unter {{supportEmail}}. Bei Fragen möchten wir Dich bitten, das Restaurant anzurufen.",
      [ORDER_REJECTED_REASON.ORDER_TOO_BIG]:
        "Leider können wir eine derart große Bestellung grad nicht vorbereiten. Wenn es in Ordnung ist, versuche es bitte noch einmal mit kleinerer(n) Bestellung(en). Wir haben das Geld bereits an dich zurücküberwiesen und du solltest es spätestens innerhalb von 4 Werktagen erhalten. Solltest du das Geld nicht innerhalb von 4 Tagen erhalten, schreibe bitte an unseren digitalen Partner {{provider}} unter {{supportEmail}}. Bei Fragen möchten wir Dich bitten, das Restaurant anzurufen.",
      [ORDER_REJECTED_REASON.CUSTOMER_MISTAKE]: '',
      [ORDER_REJECTED_REASON.OTHER]: '',
    },
    pickup_time_changed:
      "{{company}} änderte die Zeit von {{initialTime}} auf {{currentTime}}",
  },
  room_service_instructions: {
    title: 'Anweisungen',
    location_types: {
      [RoomServiceLocationType.RoomService]: 'Zimmerservice, Nummer {{details}}',
      [RoomServiceLocationType.TableService]: 'Tischservice, Nummer {{details}}',
    },
    location_types_without_number: {
      [RoomServiceLocationType.RoomService]: 'Zimmerservice',
      [RoomServiceLocationType.TableService]: 'Tischservice',
    },
  },
  pickup_instructions: {
    title: "Abholinfo",
    description:
      "🗣 Nenne uns deine Bestellnummer, wenn du deine Bestellung abholst.",
  },
  delivery_instructions: {
    title: "Lieferinformation",
    address: "Deine Addresse",
    note: "Bemerkung: ",
  },
  rewards: {
    title: "Deine Prämien",
  },
  order_details: {
    title: "Bestell Details",
  },
  payment_breakdown: {
    free: "Gratis",
    deal_applied: "Deal angewandt",
    points_applied: "Punkte angewandt",
    promo_applied: "Promo angewandt",
  },
  price_details: {
    title: "Preis Details",
    original: "Zwischensumme",
    tip: "Trinkgeld",
    total: "Gesamt",
    delivery_fee: "Liefergebühr",
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal Gebühr',
    },
    service_fee: "Onlinezuschlag",
    tax: 'Taxes',
  },
  review_form: {
    title: "Wie gefällt dir {{name}}?",
    description: "Dein Feedback ist anonym und hilft uns besser zu werden.",
  },
  upload_google_review: {
    title: "Wir belohnen dich",
  },
  toast_messages: {
    share_experience:
      "Wie findest du unser Lokal? Bitte teile es mit uns unten 😊",
  },
  error_messages: {
    failed_to_load:
      "Bestellung konnte nicht geladen werden. Bitte versuche es erneut.",
  },
};
